import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../../services/AppComponentBase';
import {ScannerTrialInfoImages} from '../ScannerTrialInfoImages/ScannerTrialInfoImages.component';




@Component({
    selector: "modal-ScannerTrialInfoImagesMobile",
    template: require('./ScannerTrialInfoImagesMobile.component.html'),
    styles: [require('./ScannerTrialInfoImagesMobile.component.css')]
})

export class ScannerTrialInfoImagesMobile extends ScannerTrialInfoImages
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector,activeModal);
    }

    public get isHorizontal()
    {
       return this.workspace.horizontalMode;
    }
}


